<template>
  <el-sub-menu v-if="menuItem.childMenuList && menuItem.childMenuList.length > 0" :index="menuItem.menuId">
    <template #title>
      <div class="menu-content">
        <template v-if="menuItem.menuIcon">
          <img
            v-if="iconUrl(menuItem)"
            :src="iconUrl(menuItem)"
            alt=""
            width="25"
            height="25"
            style="margin-bottom: 6px"
            class="iconfont"
          />
          <i v-else :class="[menuItem.menuIcon]"></i>
        </template>
        <span class="menu-name" :style="menuNameStyle" :title="$t(menuItem.menuName)">{{ $t(menuItem.menuName) }}</span>
      </div>
    </template>
    <template v-for="item in menuItem.childMenuList" :key="item.menuRouteUrl">
      <MenuItem :menuItem="item" />
    </template>
  </el-sub-menu>
  <el-menu-item class="menu-content" v-else :index="menuItem.menuRouteUrl">
    <template v-if="menuItem.menuIcon">
      <img
        v-if="iconUrl(menuItem)"
        :src="iconUrl(menuItem)"
        alt=""
        width="25"
        height="25"
        style="margin-bottom: 6px"
        class="iconfont"
      />
      <i v-else :class="[menuItem.menuIcon]"></i>
    </template>
    <template #title>
      <span class="menu-name" :style="menuNameStyle" :title="$t(menuItem.menuName)">{{ $t(menuItem.menuName) }}</span>
    </template>
  </el-menu-item>
</template>

<script>
import { defineComponent } from 'vue'
import ElSubMenu from '@/components/el/menu/submenu.vue'
import ElMenuItem from '@/components/el/menu/menuItem.vue'
import { $t, isCN } from '@/lang/index'

export default defineComponent({
  name: 'MenuItem',
  data() {
    return {
      iconMap: {
        main_menu_lct: 'lct_icon.svg',
        物流控制塔: 'lct_icon.svg',
        网络规划管理: 'network_icon.svg'
      }
    }
  },
  props: {
    menuItem: Object
  },
  components: {
    ElSubMenu,
    ElMenuItem
  },
  computed: {
    menuNameStyle() {
      return {
        fontSize: isCN.value ? '14px' : '12px'
      }
    }
  },
  methods: {
    iconUrl(item) {
      const isHttpUrl = item.menuIcon.indexOf('http') !== -1
      if (isHttpUrl) {
        return item.menuIcon
      } else if (this.iconMap[item.menuName]) {
        return require('@/assets/define-icon/' + this.iconMap[item.menuName])
      } else {
        return null
      }
    }
  }
})
</script>

<style lang="scss" scoped>
.el-sub-menu {
  .iconfont {
    margin-right: 5px;
    width: 24px;
    text-align: center;
    font-size: 18px;
    vertical-align: middle;
  }
}

.menu-content {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.menu-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  font-size: 12px;
}

:deep(.el-sub-menu .el-menu-item) {
  padding-right: 20px;
}
</style>
